import { fetch } from '../request'
import type { IResponse } from '../interface/common'
import {
  type InviteInfoParams,
  type InviteInfoItem,
  type ActivityItem,
} from '../interface/marketing'
/**
 * 获取邀请链接
 * @param data
 * @returns
 */
export const getPullNewLink = () => {
  return fetch('/attraction/link/my_link/', {
    method: 'GET',
  })
}

/**
 * 获取排行榜
 * @param data
 * @returns
 */
export const getRankList = (params: any) => {
  return fetch('/attraction/rank/', {
    method: 'GET',
    params,
  })
}

/**
 * 拉新记录
 * @param data
 * @returns
 */
export const getInviteRecordInfo = (params: InviteInfoParams) => {
  return fetch<IResponse<InviteInfoItem[]>>('/attraction/record/', {
    method: 'GET',
    params,
  })
}

/**
 * 拉新记录已读
 * @param data
 * @returns
 */
export const readRecordType = (
  is_invitee: number,
  params: { record_id: number }
) => {
  return fetch(`/attraction/record/read/?is_invitee=${is_invitee}`, {
    method: 'POST',
    body: params,
  })
}

/**
 * 活动详情
 * @param data
 * @returns
 */
export const getInviteActivity = (params: { is_last_version: 1; many: 1 }) => {
  return fetch<IResponse<ActivityItem[]>>('/attraction/activity/', {
    method: 'GET',
    params,
  })
}
